import styled from 'styled-components';

import Input from 'styles/Input';

const EmailInput = styled(Input)`
  margin: 0 0 15px;
  font-size: 15px;
  padding: 15px;
  background-color: var(--bg-color-text-input);
`;

export default EmailInput;
